import React from 'react';
import { Button } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';
import StatePanel from './StatePanel';

interface ErrorStateProps {
    /** Bold heading. */
    title?: string;
    /** Explanation shown under the title. */
    message?: React.ReactNode;
    /** When provided, renders a retry button that calls this. */
    onRetry?: () => void;
    /** Retry button label. */
    retryLabel?: string;
}

/**
 * Reusable error card: an error-tinted dashed panel with an icon, title, message
 * and an optional retry action. Shares its shell with InsightsEmptyState (see
 * StatePanel) so empty and error states read as a consistent family.
 */
const ErrorState: React.FC<ErrorStateProps> = ({
    title = 'Something went wrong',
    message = 'Please try again.',
    onRetry,
    retryLabel = 'Try again',
}) => (
    <StatePanel tone="error" icon={<ErrorOutline color="error" />} title={title} description={message}>
        {onRetry && (
            <Button
                variant="outlined"
                startIcon={<Refresh fontSize="small" />}
                onClick={onRetry}
                sx={{ mt: 0.5, textTransform: 'none', borderRadius: 2 }}
            >
                {retryLabel}
            </Button>
        )}
    </StatePanel>
);

export default ErrorState;
